var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#3182ce;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-92 -236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1037 225)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(1129 11)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.155-6.811V-4.3H4.361V-7.562a11.305,11.305,0,0,0,3.5-2.557,3.628,3.628,0,0,0,.709-2.116,2.336,2.336,0,0,0-.811-1.907A3.448,3.448,0,0,0,5.5-14.813,7.936,7.936,0,0,0,1.676-13.7H1.558v-2.052a11.9,11.9,0,0,1,4.093-.773A5.505,5.505,0,0,1,9.287-15.4a3.708,3.708,0,0,1,1.348,3,4.792,4.792,0,0,1-.8,2.675A11.5,11.5,0,0,1,6.155-6.811ZM6.392,0H4.2V-2.267H6.392Z",
    transform: "translate(101 259)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon_help.edd108258d13b8ba6d90b99826be92be.svg";
export { ForwardRef as ReactComponent };